/**
 * Header State Configuration
 *
 * Contains all constants, action types, and initial state definitions
 * for the header state management system.
 */

// Initial state structure
export const initialHeaderState = {
  menu: {
    isViewFilesMenuVisible: false,
    isHamburgerMenuVisible: false,
    isAccountMenuVisible: false,
    isMobileTopLevelMenuVisible: false,
    isSignInHamburgerMenuVisible: false,
    isCreateKinCategoryMenuVisible: false,
    isSubNavVisible: false,
    isAccountModalVisible: false,
    isLGModalOpen: false,
    currentHeaderClick: '',
    activeMainCategory: null
  },
  search: {
    searchTerm: ''
  },
  timeouts: {
    viewFilesTimeoutId: null,
    kinCategoriesTimeoutId: null,
    uploadTimeoutId: null,
    accountTimeoutId: null,
    buildYourOwnTimeoutId: null
  },
  notifications: {
    showNotification: false,
    welcomeMessage: null
  }
}

// Action types for state management
export const HEADER_STATE_ACTIONS = {
  // Menu actions
  TOGGLE_MENU: 'TOGGLE_MENU',
  SET_MENU_VISIBILITY: 'SET_MENU_VISIBILITY',
  SET_CURRENT_CLICK: 'SET_CURRENT_CLICK',
  SET_ACTIVE_CATEGORY: 'SET_ACTIVE_CATEGORY',
  CLOSE_ALL_MENUS: 'CLOSE_ALL_MENUS',

  // Search actions
  SET_SEARCH_TERM: 'SET_SEARCH_TERM',
  CLEAR_SEARCH: 'CLEAR_SEARCH',

  // Timeout actions
  SET_TIMEOUT_ID: 'SET_TIMEOUT_ID',
  CLEAR_TIMEOUT_ID: 'CLEAR_TIMEOUT_ID',
  CLEAR_ALL_TIMEOUTS: 'CLEAR_ALL_TIMEOUTS',

  // Notification actions
  SET_NOTIFICATION: 'SET_NOTIFICATION',
  CLEAR_NOTIFICATION: 'CLEAR_NOTIFICATION',
  SET_WELCOME_MESSAGE: 'SET_WELCOME_MESSAGE',

  // Bulk actions
  RESET_STATE: 'RESET_STATE',
  RESTORE_STATE: 'RESTORE_STATE',
  BATCH_UPDATE: 'BATCH_UPDATE'
}

// Storage configuration
export const STORAGE_KEY = 'kinstack_header_state'

// Timeout configuration
export const TIMEOUT_DURATION = 5000
